module.exports = __webpack_public_path__ + "static/media/mail.7a4baaa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/mail.svg
// module id = 352
// module chunks = 0